/* import __COLOCATED_TEMPLATE__ from './scim-admin-profile-update-details.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type AppAdminEvent from 'embercom/models/app-admin-event';

interface ScimAdminProfileUpdateDetailsSignature {
  Args: {
    event: AppAdminEvent;
  };
}

export default class ScimAdminProfileUpdateDetails extends Component<ScimAdminProfileUpdateDetailsSignature> {
  @tracked showModal = false;

  @action
  toggleModal() {
    this.showModal = !this.showModal;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TableCells::AdminEvents::ScimAdminProfileUpdateDetails': typeof ScimAdminProfileUpdateDetails;
  }
}
